import React from "react";
import {
    createStyles,
    Theme,
    Typography,
    withStyles,
    WithStyles
} from "@material-ui/core";
import * as ParcelColumnCss from "../../../styles/ParcelColumnCss";

type ParcelColumnHeadersProps = WithStyles<
    typeof styles | typeof ParcelColumnCss.styles
> & {
    completed: boolean;
    isLive: boolean;
    showMobile: boolean;
};

const styles = (theme: Theme) =>
    createStyles({
        headerText: {
            [theme.breakpoints.down("xs")]: { fontSize: 12 },
            color: "#C0C0C0",
            fontSize: 13
        },
        panelColumnHeadersDesktop: {
            [theme.breakpoints.down("sm")]: { display: "none" },
            display: "flex"
        },
        panelColumnHeadersMobile: {
            [theme.breakpoints.up("md")]: { display: "none" },
            display: "flex"
        },
        ...ParcelColumnCss.styles(theme)
    });

class ParcelColumnHeaders extends React.PureComponent<
    ParcelColumnHeadersProps,
    {}
> {
    public render() {
        const classes = this.props.classes;
        const completed = this.props.completed;
        const isLive = this.props.isLive;
        const showMobile = this.props.showMobile;

        return (
            <div
                className={
                    showMobile
                        ? classes.panelColumnHeadersMobile
                        : classes.panelColumnHeadersDesktop
                }
            >
                {!showMobile && (
                    <div
                        className={
                            isLive
                                ? classes.columnParcelImageLive
                                : classes.columnParcelImageNotLive
                        }
                    >
                        <Typography
                            component="span"
                            variant="button"
                            className={classes.headerText}
                        >
                            Parcel
                        </Typography>
                    </div>
                )}
                <div className={classes.columnFirst}>
                    <Typography
                        component="span"
                        variant="button"
                        className={classes.headerText}
                    >
                        {completed
                            ? "Finished On"
                            : isLive
                              ? "Time Left"
                              : "Start Time"}
                    </Typography>
                </div>
                {!isLive && !completed && (
                    <div className={classes.columnSecond}>
                        <Typography
                            component="span"
                            variant="button"
                            className={classes.headerText}
                        >
                            End Time
                        </Typography>
                    </div>
                )}
                <div
                    className={
                        isLive
                            ? classes.columnBidAmountLive
                            : !completed
                              ? classes.columnBidAmountNotLive
                              : classes.columnBidAmountCompleted
                    }
                >
                    <Typography
                        component="span"
                        variant="button"
                        className={classes.headerText}
                    >
                        {completed ? "Final" : !isLive ? "Starting Bid" : ""}
                    </Typography>
                </div>
                {isLive && !showMobile && (
                    <div className={classes.columnBidButtonLive}>&nbsp;</div>
                )}
            </div>
        );
    }
}

export default withStyles(styles)(ParcelColumnHeaders);
